// extracted by mini-css-extract-plugin
export var actionButton = "_rz-0";
export var actionMenuContainer = "_rz-i";
export var bubble = "_rz-2";
export var bubbleActionMenu = "_rz-j";
export var bubbleContext = "_rz-6";
export var bubbleItems = "_rz-7";
export var customer = "_rz-3";
export var divider = "_rz-8";
export var fileList = "_rz-9";
export var hiddenComment = "_rz-o";
export var infoAbove = "_rz-a";
export var internal = "_rz-4";
export var lightActionButton = "_rz-1";
export var link = "_rz-b";
export var merchant = "_rz-5";
export var message = "_rz-c";
export var profilePicture = "_rz-e";
export var quillToolbarContainer = "_rz-f";
export var senderDate = "_rz-g";
export var senderDateCustomer = "_rz-h";
export var senderName = "_rz-d";
export var time = "_rz-k";
export var uploadedImage = "_rz-l";
export var username = "_rz-m";
export var xsmall = "_rz-n";